/* Keep the support launcher in the corner, above visible bottom controls. */
(() => {
  const root = document.documentElement;
  const barSelector = '.mas-mobile-dock, .mas-product-bar, .hdt-sticky-btn-atc';
  const launcherSelector = 'img[alt="Launcher icon"][src*="chative.io"]';
  const rewardsSelector = '#smile-ui-container .smile-launcher-frame-container';
  let bars = [];
  let launcher;
  let launcherNodes = [];
  let previousClearance;
  let previousRewardsClearance;
  let refresh = true;
  let frame;
  const update = () => {
    frame = null;
    if (refresh) {
      refresh = false;
      barObserver.disconnect();
      sizeObserver.disconnect();
      bars = [...document.querySelectorAll(barSelector)];
      bars.forEach(bar => {
        barObserver.observe(bar, { attributes:true, attributeFilter:['class','hidden','data-visible','style'] });
        sizeObserver.observe(bar);
      });
      const icon = document.querySelector(launcherSelector);
      launcher = icon?.parentElement;
      while (launcher && getComputedStyle(launcher).position !== 'absolute') launcher = launcher.parentElement;
      launcherNodes = [];
      // Chat can change its own offset after mounting or after closing its panel.
      // Observe only the launcher ancestry, not unrelated app DOM changes.
      for (let node = icon; node && node !== document.body; node = node.parentElement) {
        launcherNodes.push(node);
        barObserver.observe(node, { attributes:true, attributeFilter:['class','hidden','style'] });
      }
      if (launcher) sizeObserver.observe(launcher);
    }
    const chatRect = launcher?.getBoundingClientRect();
    const chatLeft = chatRect?.width ? chatRect.left : innerWidth - 76;
    const chatRight = chatRect?.width ? chatRect.right : innerWidth - 16;
    let clearance = 0;
    bars.forEach(bar => {
      const style = getComputedStyle(bar);
      const rect = bar.getBoundingClientRect();
      if (style.position !== 'fixed' || style.visibility === 'hidden' || Number(style.opacity) === 0 ||
          !rect.width || !rect.height || rect.top < 0 || rect.top >= innerHeight || rect.bottom <= 0 ||
          rect.right <= chatLeft || rect.left >= chatRight) return;
      clearance = Math.max(clearance, Math.ceil(innerHeight - rect.top));
    });
    if (clearance !== previousClearance) {
      root.style.setProperty('--mas-chat-clearance', `${clearance}px`);
      previousClearance = clearance;
    }
    // Measure after applying bottom-bar clearance so the two apps cannot drift
    // into each other when chat adds an offset or uses a larger launcher.
    const positionedChat = launcher?.getBoundingClientRect();
    const rewardsClearance = positionedChat?.width && positionedChat.height &&
      positionedChat.bottom > 0 && positionedChat.top < innerHeight &&
      getComputedStyle(launcher).visibility !== 'hidden' && Number(getComputedStyle(launcher).opacity) !== 0
      ? Math.max(clearance + 96, Math.ceil(innerHeight - positionedChat.top + 20))
      : clearance + 96;
    if (rewardsClearance !== previousRewardsClearance) {
      root.style.setProperty('--mas-rewards-clearance', `${rewardsClearance}px`);
      previousRewardsClearance = rewardsClearance;
    }
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
  const barObserver = new MutationObserver(queue);
  const sizeObserver = new ResizeObserver(queue);
  // Product/review apps change hundreds of unrelated classes during startup.
  // Only remeasure for our bottom controls or a newly mounted chat launcher.
  const relevant = node => node.nodeType === 1 &&
    (node.matches(barSelector + ', ' + launcherSelector + ', ' + rewardsSelector) || node.querySelector(barSelector + ', ' + launcherSelector + ', ' + rewardsSelector));
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevant))) return;
    refresh = true;
    queue();
  }).observe(document.body, { childList:true, subtree:true });
  addEventListener('resize', queue, { passive: true });
  addEventListener('scroll', queue, { passive: true });
  window.visualViewport?.addEventListener('resize', queue, { passive: true });
  document.addEventListener('transitionend', event => {
    if (event.target.closest(barSelector) || launcherNodes.includes(event.target)) queue();
  });
  queue();
})();
